import { createGlobalStyle } from "styled-components";

// Define the global styles for fonts
const GlobalFonts = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Open+Sans:wght@300;400;600&display=swap');

  :root {
    --font-heading: 'Montserrat', sans-serif;
    --font-body: 'Open Sans', sans-serif;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-heading);
  }

  body {
    font-family: var(--font-body);
  }
`;

export default GlobalFonts;
